// Shared presentational primitives for the intelligence terminal UI.

const VERDICT_STYLE = {
  EMERGING: "text-emerald-400 bg-emerald-950/40 border-emerald-500/50",
  WATCH: "text-amber-400 bg-amber-950/40 border-amber-500/50",
  REJECT: "text-rose-500 bg-rose-950/20 border-rose-900/60",
};

export function VerdictBadge({ decision, className = "" }) {
  const s = VERDICT_STYLE[decision] || "text-zinc-400 bg-zinc-900 border-zinc-700";
  return (
    <span
      data-testid={`verdict-${(decision || "none").toLowerCase()}`}
      className={`inline-block px-2 py-0.5 text-[11px] font-mono font-semibold tracking-widest border rounded-none ${s} ${className}`}
    >
      {decision || "—"}
    </span>
  );
}

const PROV = {
  Observed: "text-zinc-200 bg-zinc-800 border-zinc-600 border-solid",
  Calculated: "text-blue-400 bg-blue-950 border-blue-800 border-solid",
  Estimated: "text-orange-400 bg-orange-950/30 border-orange-800 border-dashed",
  "AI Interpretation": "text-indigo-400 bg-indigo-950 border-indigo-800 border-solid",
};

export function ProvenanceTag({ type }) {
  const s = PROV[type] || PROV.Observed;
  return (
    <span
      data-testid={`provenance-${(type || "").replace(/\s+/g, "-").toLowerCase()}`}
      className={`inline-block px-2 py-0.5 text-[10px] font-mono border rounded-sm ${s}`}
    >
      {type}
    </span>
  );
}

export function ConfidenceTag({ level }) {
  const map = {
    HIGH: "text-emerald-400 border-emerald-700",
    MEDIUM: "text-amber-400 border-amber-700",
    LOW: "text-rose-400 border-rose-800",
  };
  return (
    <span
      data-testid={`confidence-${(level || "").toLowerCase()}`}
      className={`inline-block px-2 py-0.5 text-[10px] font-mono border rounded-none ${map[level] || "text-zinc-400 border-zinc-700"}`}
    >
      CONFIDENCE: {level || "—"}
    </span>
  );
}

export function ScoreBar({ label, value, testid }) {
  const v = value == null ? null : Math.round(value);
  const color = v == null ? "#3f3f46" : v >= 60 ? "#34d399" : v >= 40 ? "#fbbf24" : "#f43f5e";
  return (
    <div data-testid={testid} className="border border-[#27272A] bg-[#18181B] p-4">
      <div className="flex items-center justify-between mb-2">
        <span className="text-[11px] uppercase tracking-widest text-[#A1A1AA] font-mono">{label}</span>
        <span className="font-mono text-lg font-semibold" style={{ color }}>
          {v == null ? "N/A" : v}
        </span>
      </div>
      <div className="h-1.5 bg-[#27272A]">
        <div className="h-full transition-all duration-500" style={{ width: `${v || 0}%`, background: color }} />
      </div>
    </div>
  );
}

export function Panel({ title, right, children, className = "" }) {
  return (
    <div className={`border border-[#27272A] bg-[#18181B] ${className}`}>
      {title && (
        <div className="flex items-center justify-between px-4 py-3 border-b border-[#27272A]">
          <h3 className="text-xs uppercase tracking-widest text-[#A1A1AA] font-mono">{title}</h3>
          {right}
        </div>
      )}
      <div className="p-4">{children}</div>
    </div>
  );
}
